import { render, staticRenderFns } from "./GlobalListRanter.vue?vue&type=template&id=3193e45e&"
import script from "./GlobalListRanter.vue?vue&type=script&lang=ts&"
export * from "./GlobalListRanter.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalListRanter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports